import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, Subscription, timer } from 'rxjs';
import { first, startWith, switchMap, tap } from 'rxjs/operators';
import { SnackbarStatus } from './snackbar-status.enum';

@Injectable({ providedIn: 'root' })
export class SnackbarService {

    public renderOnDom$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public show$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public smallFont$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public message$: BehaviorSubject<string> = new BehaviorSubject('Success');
    public type$: BehaviorSubject<SnackbarStatus> = new BehaviorSubject<SnackbarStatus>(SnackbarStatus.SUCCESS);

    private resetSnackbar: Subject<number> = new Subject<number>();
    private resetSubscription$!: Subscription;

    constructor() {
    }

    public showSnackbar(
        type: SnackbarStatus,
        message: string,
        duration: number = 3000,
        smallFont: boolean = false,
    ) {
        this.renderOnDom$.next(true);
        this.message$.next(message);
        this.type$.next(type);

        // snackbar is already displayed
        if (this.show$.value) {
            this.resetSnackbar.next(duration);
        } else {
            setTimeout(() => {
                this.show$.next(true);
            })
            this.smallFont$.next(smallFont);

            this.resetSubscription$ = this.resetSnackbar.pipe(
                startWith(duration),
                switchMap((duration) => timer(duration).pipe(
                    tap(() => {
                        this.show$.next(false);
                        setTimeout(() => this.renderOnDom$.next(false), 300)
                        this.smallFont$.next(false);
                    }),
                )),
                first(), // Destroy subscription after the timer has expired
            ).subscribe();
        }
    }

}
